class Templates {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/templates`;
    this.apiClient = apiClient;

  }

  async getTemplates() {

    const path = `${this.basePath}/all`;

    return this.apiClient.get(path, {}, {});

  }

  async createTemplateCloner(templateId, payload) {

    const path = this.basePath + '/:templateId/clones';

    return this.apiClient.post(path, { templateId }, {}, payload);

  }

  async getTemplateClonerById(templateId, clonerId) {

    const path = this.basePath + '/:templateId/clones/:clonerId';

    return this.apiClient.get(path, { templateId, clonerId }, {});

  }

}

export default Templates;